import React, { useState } from "react";
import { Button, Icon, SystemMessage, Tooltip } from "@shoptet/ui";
import {
  AdminMetaAdsOrganizationsDocumentT,
  useAdminResendMetaPageClaimRequestMutation,
} from "../../graphql/generated/graphql";
import { ModalWrapper } from "../ModalWrapper";

type ResendMetaPageClaimButtonPropsT = {
  apiToken: string;
};

const ResendMetaPageClaim = ({ apiToken, onClose }: ResendMetaPageClaimButtonPropsT & { onClose: () => void }) => {
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  const [resend, { loading }] = useAdminResendMetaPageClaimRequestMutation({
    refetchQueries: [AdminMetaAdsOrganizationsDocumentT],
    awaitRefetchQueries: true,
    onCompleted(data) {
      const payload = data.adminResendMetaPageClaimRequest;
      if (payload?.success) {
        onClose();
      } else {
        setErrorMessage(payload?.errors?.[0] ?? "Mutation failed");
      }
    },
    onError(error) {
      setErrorMessage(error.message);
    },
  });

  const handleSend = () => {
    setErrorMessage(null);
    resend({
      context: {
        headers: {
          Authorization: `ApiToken ${apiToken}`,
        },
      },
    });
  };

  return (
    <div>
      <p>
        Tímto vynulujeme stav claim requestu a znovu zařadíme
        <code> MetaAds::ClaimPage</code> do fronty. Použij pouze pokud jsi smazal pending request přímo v Meta Business
        Manageru.
      </p>
      {errorMessage && <SystemMessage description={errorMessage} level="error" />}
      <Button disabled={loading} variant="action" onClick={handleSend}>
        {loading ? "Odesílám..." : "Znovu zaslat claim request"}
      </Button>
    </div>
  );
};

export const ResendMetaPageClaimButton = ({ apiToken }: ResendMetaPageClaimButtonPropsT) => {
  const [isOpen, setOpen] = useState(false);
  return (
    <>
      <Tooltip closeDelay={300} content="Znovu zaslat claim request (po manuálním smazání na Meta)">
        <span style={{ cursor: "pointer" }} onClick={() => setOpen(true)}>
          <Icon icon="shp-loop" variant="secondary" />
        </span>
      </Tooltip>

      <ModalWrapper isOpen={isOpen} title="Znovu zaslat Meta page claim request" onClose={() => setOpen(false)}>
        {isOpen && <ResendMetaPageClaim apiToken={apiToken} onClose={() => setOpen(false)} />}
      </ModalWrapper>
    </>
  );
};
